export class searchResultArray<T> {
  count: number;
  result: T[];

  constructor(item?: searchResultArray<T>) {
    this.result = item?.result ?? [];
    this.count = item?.count ?? 0;
  }
}
